<template>
  <div class="comHome">
    <div class="banner">
      <div class="bannerBg">
        <el-image :src="bannerBgUrl" style="max-width: 980px;max-height:180px;">
            <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="el-image__error">
                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
            </div>
        </el-image>
      </div>
      <div class="bannerImg pw">
        <!-- <el-image :src="bannerUrl" style="width: 100%;height: 100%"></el-image> -->
        <el-image :src="bannerUrl" style="width: 100%;height: 100%">
            <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="el-image__error">
                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
            </div>
        </el-image>
      </div>
    </div>
    <div class="notice" v-if="noticeList.length>2">
      <div class="title">公告：</div>
      <div :class="noticeBoolean && 'main'" ref="noticeRef">
        {{ noticeList }}
      </div>
      <div v-if="noticeBoolean" :class="noticeBoolean && 'main'">
        {{ noticeList }}
      </div>
      <!-- <el-carousel height="40px" direction="horizontal" :autoplay="noticeLoop"
                         indicator-position="none" :loop="noticeLoop"
                         arrow="never" :interval="4000">
                <el-carousel-item v-for="(item) in noticeList" :key="item.id">
                    <div>{{item.detail}}</div>
                </el-carousel-item>
            </el-carousel> -->
    </div>
    <div class="fix" :style="noticeList.length>2?'':'margin-top:10px'">
      <div class="conLeft fl w780">
        <advertSwiper :list="advertSwiperList"></advertSwiper>
        <div class="result mt30">
          <template>
            <div
              v-if="preSession.sessionCode"
              :class="{ auctionBox2: rankTitleList.length == 2 }"
              style="width: 100%"
            >
              <div class="resultTitleBox">
                <span class="resultTitle conTitle">拍卖预展</span>
              </div>
              <ul class="resultUl borderLine flex">
                <homeAuctionPreview
                  v-for="(preItem, indexPre) in aucPreviewList"
                  :key="indexPre * 3 + 3"
                  :class="{ resultItem: aucPreviewList.length > 1 }"
                  :list="preSession"
                ></homeAuctionPreview>
              </ul>
            </div>
            <div
              v-if="preSession.sessionCode"
              :class="{ auctionBox2: rankTitleList.length == 2 }"
              style="width: 100%"
            >
              <div class="resultTitleBox">
                <span class="resultTitle conTitle">拍卖结果</span>
              </div>
              <div>
                <ul class="resultUl  borderLine flex">
                  <homeAuctionResult
                    v-for="(goodItem, indexPre) in auctionGoodList"
                    :key="indexPre * 3 + 30"
                    :class="{ resultItem: auctionGoodList.length > 1 }"
                    :title-list="resultSessionTitle0"
                    :list="resultSession0"
                  ></homeAuctionResult>
                </ul>
              </div>
            </div>
            <div
              v-if="!preSession.sessionCode"
              :class="{ auctionBox2: rankTitleList.length == 2 }"
              style="width: 100%"
            >
              <div class="resultTitleBox">
                <span class="resultTitle conTitle">拍卖结果</span>
              </div>
              <div class="ulFlex">
                <ul class="resultUl  borderLine flex">
                  <homeAuctionResult
                    v-for="(goodItem, indexPre) in auctionGoodList"
                    :key="indexPre * 3 + 30"
                    :class="{ resultItem: auctionGoodList.length > 1 }"
                    :title-list="resultSessionTitle0"
                    :list="resultSession0"
                  ></homeAuctionResult>
                </ul>
                <ul class="resultUl  borderLine flex">
                  <homeAuctionResult
                    v-for="(goodItem, indexPre) in auctionGoodList"
                    :key="indexPre * 3 + 30"
                    :class="{ resultItem: auctionGoodList.length > 1 }"
                    :title-list="resultSessionTitle1"
                    :list="resultSession1"
                  ></homeAuctionResult>
                </ul>
              </div>
            </div>
          </template>
        </div>
        <!-- 特色专场 -->
        <specialFeatures
          v-if="isStateList.index_organ_special === 0 && special_list.length"
          :special_list="special_list"
        ></specialFeatures>
        <!--预展精品-->
        <transBoutique
          v-if="
            isStateList.index_organ_pregood === 0 && yuZhanTransBoutiqueList.length
          "
          class="mt30"
          :name="'估价'"
          :title="'预展精品'"
          :list="yuZhanTransBoutiqueList"
        ></transBoutique>
        <div
          class="goodRank mt25"
          v-if="pre_evaluationrank.length || pre_clickrank.length"
        >
          <div class="goodTitleBox">
            <span class="goodTitle auctionFont" >预展拍品榜</span>
          </div>
          <ul class="flex goodRankUl">
            <goodRank :rankTitle="'最热估值拍品榜'" :list="pre_evaluationrank" :title="'估价'" :t="t"></goodRank>
            <goodRank :rankTitle="'用户关注拍品榜'" :list="pre_clickrank" :title="'估价'" :t="t"></goodRank>
          </ul>
        </div>
        <!--成交精品欣赏-->
        <transBoutique
          v-if="
            isStateList.index_organ_reaultgood === 0 && transBoutiqueList.length
          "
          class="mt30"
          :name="'成交价'"
          :title="'成交精品欣赏'"
          :list="transBoutiqueList"
          :t="t"
        ></transBoutique>
        <div
          class="goodRank mt25"
          v-if="isStateList.index_organ_reaultrank === 0 && isGoodRankList"
        >
          <div class="goodTitleBox">
            <span class="goodTitle auctionFont" >成交拍品榜</span>
          </div>
          <ul class="flex goodRankUl">
            <goodRank
              v-for="(item, i) in rankTitleList"
              :key="item.id"
              :rankTitle="item.title"
              :list="goodRankList[i]"
              :title="'成交价'"
              :t="t"
            ></goodRank>
          </ul>
        </div>
      </div>
      <div class="conRight padRight fr w380 borderLine">
        <div
          class="comInfo"
          v-if="isStateList && isStateList.index_organ_info === 0 && companyInfoList"
        >
          <div class="comTitle">
            <span class="auctionFont conTitle">公司信息</span>
            <!-- <span v-if="!isFocus" class="focusBtn"><i></i>加关注</span>
            <span v-else class="focusBtn"><i></i>已关注</span> -->
          </div>
          <companyInfo :list="companyInfoList"></companyInfo>
        </div>
        <div
          class="comInfo mt16"
          v-if="isStateList.index_organ_news === 0 && newsCenterList.length"
        >
          <div class="comTitle">
            <span class="auctionFont conTitle">新闻中心</span>
          </div>
          <baseList
            class="newsList mt16"
            :dataList="newsCenterList"
            :showTag="showNewsTag"
          ></baseList>
        </div>
        <div class="comInfo" v-if="isStateList.index_organ_service === 0">
          <span class="auctionFont conTitle mtb17">用户服务</span>
          <service :list="serviceList"></service>
        </div>
        <div
          class="comInfo mt22"
          v-if="isStateList.index_organ_contact === 0 && contactList"
        >
          <div class="comTitle">
            <span class="auctionFont conTitle">联系我们</span>
          </div>
          <contact :list="contactList"></contact>
        </div>
        <div
          class="comInfo mt16"
          v-if="isStateList.index_organ_auctions === 0 && goodCenterList.length"
        >
          <span class="auctionFont conTitle">拍品中心</span>
          <goodCenter class="newsList mt16" :list="goodCenterList"></goodCenter>
        </div>
        <div class="comInfo mt16" v-if="postSendList.length">
          <span class="auctionFont conTitle">最新送拍</span>
          <newGood class="newsList mt16" :list="postSendList"></newGood>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import advertSwiper from "../components/advertSwiper";
import homeAuctionResult from "../components/homeAuctionResult";
import companyInfo from "../components/companyInfo";
import baseList from "../../morenews/components/baseList";
import service from "../components/service";
import contact from "../components/contact";
import goodCenter from "../components/goodCenter";
import goodRank from "../components/goodRank";
import homeAuctionPreview from "../components/homeAuctionPreview";
import transBoutique from "../components/previews/transBoutique";
import specialFeatures from "../components/previews/specialFeatures";
import newGood from "../components/home/newGood";
import $ from 'jquery'
import {
  postDetail,
  postResult,
  postStatic,
  postSend,
  isState,
} from "@/api/company";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "comHome",
  data() {
    return {
        t:0,
      noticeBoolean: false,
      // bannerUrl:'https://img4.artron.net/auction_manager/auction_zone_5/JG0005/2022022213364241160.jpg',
      bannerUrl: "",
      bannerBgUrl: "",
      // noticeList:[
      //     {detail:' 中国嘉德2021秋季拍卖会  总成交额 RMB 28.93 亿元 圆满收官'},
      //     {detail:' 1111中国嘉德2021秋季拍卖会  总成交额 RMB 28.93 亿元 圆满收官'},
      //     {detail:' 2222中国嘉德2021秋季拍卖会  总成交额 RMB 28.93 亿元 圆满收官'}
      // ],
      noticeList: "",
      noticeLoop: true,
      isFocus: false,
      newsCenterList: [],
      showNewsTag: false,
      rankTitleList: [
        { id: 1, title: "历史成交排行榜" },
        { id: 2, title: "最近成交排行榜" },
        { id: 3, title: "书画排行榜" },
      ],
      aucPreviewList: [{}],
      auctionGoodList: [{}],
      companyInfoList: {},
      contactList: {},
      serviceList: {},
      transBoutiqueList: [],
      yuZhanTransBoutiqueList: [],
      goodRankList: [{},{},{}],
      advertSwiperList: [],
      preSession: {},
      resultSessionTitle0: {},
      resultSession0: {},
      resultSessionTitle1: {},
      resultSession1: {},
      goodCenterList: [],
      postSendList: [],
      isStateList: {},
      special_list: [],
      pre_evaluationrank: [],
      pre_clickrank: []
    };
  },
  computed: {
    isGoodRankList() {
      return this.goodRankList[0].length || this.goodRankList[1].length || this.goodRankList[2].length
    },
      ...mapGetters({
          getIsLoadIng: "pageOrgMeta/getIsLoadIng",
          getData: "pageOrgMeta/getData",
      }),
  },
  mounted() {
      this.t = Date.now()
    const webNames = this.$router.history.current.params.name;
   this.postDetail(webNames);
      const webName = this.$route.params.name;
      if (!this.getIsLoadIng){
          let parmas = {
              type:7,
              zone_name:webName
          }
          this.setOrgMeta([parmas,()=>{
              this.filteData();
          }])
      }else{
          this.filteData();
      }
  },
    asyncData({ store,route }) {
        let params = {
            type:7,
            zone_name:route.params.name
        }
        return store.dispatch("pageOrgMeta/setOrgMeta", [params, () => {}]);
    },
  methods: {
      ...mapActions({
          setOrgMeta:"pageOrgMeta/setOrgMeta"
      }),
      filteData(){
          let data = this.$store.state["pageOrgMeta"]["data"]
          document.title = data.meta ? data.meta.title :'';
          let head = document.getElementsByTagName('head');
          this.isLoading = false
          if(!document.querySelector('meta[name=description]')){
              let meta = document.createElement('meta');
              meta.name = 'description';
              meta.content = data.meta ? data.meta.description : '';
              head[0].appendChild(meta)
          }else{
              document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
          }
      },
    //关注
    addmark() {
      var userid = this.getCookie("_at_pt_0_");
      var url = window.location.href;
      var OrganCode = "JG0005";
      if (userid) {
        $.ajax({
          type: "post",
          url: "/auctionzone/memberCollect.php",
          data: {
            OrganCode: OrganCode,
            userid: userid,
            type: 1,
          },
          success: function(data) {
            if (data == 1) {
              document.getElementById("mark_focus").className =
                "focusBtn focused";
              document.getElementById("mark_focus").innerHTML = "<i></i>已关注";
              document.getElementById("mark_focus").onclick = function() {};
              alert("关注成功");
              return false;
            } else if (data == "122100") {
              alert(
                "温馨提示：普通会员最多关注100个拍卖机构，请在删除已关注的拍卖机构后重新关注"
              );
              return false;
            } else {
              alert("关注失败，请刷新重试");
              return false;
            }
          },
        });
      } else {
        if (confirm("请登录之后再添加关注！")) {
          window.location.href =
            "http://passport.artron.net/login?appId=2&redirect=" +
            encodeURIComponent(url);
        }
      }
    },
      getCookie:function (name) {
          var arr;
          var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
          if(document.cookie.match(reg)) {
              arr = document.cookie.match(reg);
              return arr[2];
          }else {
              return null;
          }
      },
    postDetail(name) {
      postDetail({
        web_name: name,
      }).then((res) => {
        if (res.code!=0&&res.data.organ_id) {
          window.location.href = "https://auction.artron.net/org_detail/"+res.data.organ_id;
        }
        // 公告
          this.isState(res.data.organ_id);
        this.noticeList = res.data.roll_message;
        this.bannerUrl = res.data.top_bg_pic;
        this.bannerBgUrl = res.data.bg_pic;
        this.postResult(res.data.organ_id);
        this.postStatic(res.data.organ_id);
        this.postSend(res.data.organ_id);
        // 公司信息
        this.companyInfoList = {
          organ_name: res.data.organ_name,
          regiter_time: res.data.regiter_time,
          auth_num: res.data.auth_num,
          good_business: res.data.good_business,
          core_business: res.data.core_business,
          area: res.data.area,
          art_num: res.data.art_num,
          total_price: res.data.total_price,
          miroblog_pic: res.data.miroblog_pic,
        };
        // 用户服务
        this.serviceList = {
          service: res.data.service,
        };
        // 联系我们
        this.contactList = {
          address: res.data.address,
          phone: res.data.phone,
          fax: res.data.fax,
          email: res.data.email,
          web_url: res.data.web_url,
          miroblog_pic: res.data.miroblog_pic,
        };
      });
    },
    isState(id) {
      isState({
        OrganCode: id,
      }).then((res) => {
        res.data.list.map((res) => {
          this.isStateList[res.type_name] = res.status;
        });
        console.log(this.isStateList);
      });
    },
    postResult(id) {
      postResult({
        organCode: id,
      }).then((res) => {
        this.pre_evaluationrank = res.data.pre_evaluationrank;
        this.pre_clickrank = res.data.pre_clickrank;
        // 特色专场
        this.special_list = res.data.special_list;
        // 预展精品
        this.yuZhanTransBoutiqueList = res.data.goos_preview;
        // 成交精品欣赏
        this.transBoutiqueList = res.data.goos_result;
        // 历史成交排行榜
        this.goodRankList[0] = res.data.history_result_auction;
        // 最近成交排行榜
        this.goodRankList[1] = res.data.current_result_auction;
        // 书画成交排行榜
        this.goodRankList[2] = res.data.shuhua_result_art;
        // 新闻
        this.newsCenterList = res.data.news;
        // 滚图
        this.advertSwiperList = res.data.roll_pic;
        // 拍卖结果
        if(res.data.result_session&&res.data.result_session.length>0){
          this.resultSessionTitle0 = {
            name: res.data.result_session ? res.data.result_session[0].name : '',
            turnoverRatio: res.data.result_session ? res.data.result_session[0].pc_extra_info[9].text : '',
            money: res.data.result_session ? res.data.result_session[0].pc_extra_info[14].text : '',
            sessionCode: res.data.result_session ? res.data.result_session[0].sessionCode : ''
          };
        }
      
        this.resultSession0 = res.data.result_session_auction1;
        if(res.data.result_session&&res.data.result_session.length>1){
          this.resultSessionTitle1 = {
            name: res.data.result_session ? res.data.result_session[1].name : '',
            turnoverRatio: res.data.result_session ? res.data.result_session[1].pc_extra_info[9].text : '',
            money: res.data.result_session ? res.data.result_session[1].pc_extra_info[14].text : '',
            sessionCode: res.data.result_session ? res.data.result_session[1].sessionCode : ''
          };
        }
      
        this.resultSession1 = res.data.result_session_auction2;
        // 拍卖预展
        this.preSession = {
          sessionCode: res.data.pre_session ? res.data.pre_session.sessionCode : '',
          name: res.data.pre_session ? res.data.pre_session.name : '',
          auctionName: res.data.pre_session && res.data.pre_session.extraInfo ? res.data.pre_session.extraInfo[0].label : '',
          auctionTime: res.data.pre_session && res.data.pre_session.extraInfo ? res.data.pre_session.pc_extra_info[10].text.indexOf('延期') != -1 ? res.data.pre_session.pc_extra_info[10].text : res.data.pre_session.pc_extra_info[10].picType + '~'+res.data.pre_session.pc_extra_info[10].picUrl : '',
          auctionLocation: res.data.pre_session && res.data.pre_session.pc_extra_info ? res.data.pre_session.pc_extra_info[11].text : '',
          previewName: res.data.pre_session && res.data.pre_session.extraInfo? res.data.pre_session.extraInfo[1].label : '',
          previewTime: res.data.pre_session && res.data.pre_session.pc_extra_info ? res.data.pre_session.pc_extra_info[12].text.indexOf('延期') != -1 ? res.data.pre_session.pc_extra_info[12].text : res.data.pre_session.pc_extra_info[12].picType + '~'+res.data.pre_session.pc_extra_info[12].picUrl : '',
          previewLocation: res.data.pre_session && res.data.pre_session.pc_extra_info? res.data.pre_session.pc_extra_info[13].text : '',
          result: res.data.pre_session && res.data.pre_session.specialsList ? res.data.pre_session.specialsList.length : 0,
        };
      });
    },
    postStatic(id) {
      postStatic({
        organ_code: id,
      }).then((res) => {
        this.goodCenterList = res.data.organ_art_static;
      });
    },
    postSend(id) {
      postSend({
        organCode: id,
      }).then((res) => {
        // 最新送拍 最大显示四张
        this.postSendList = res.data.list.slice(0, 4);
        this.gundong()
      });
    },
    gundong() {
      if(this.$refs.noticeRef && this.$refs.noticeRef.offsetWidth > 950) {
        this.noticeBoolean = true;
      }
    }
  },
  components: {
    advertSwiper,
    homeAuctionResult,
    companyInfo,
    baseList,
    service,
    contact,
    goodCenter,
    goodRank,
    homeAuctionPreview,
    transBoutique,
    newGood,
    specialFeatures,
  },
};
</script>

<style scoped lang="scss">
@import url(../../../assets/css/reset.css);
@import "@/assets/css/auctionCompany.scss";
.comHome {
  .banner {
    margin-top: 13px;
    position: relative;
    height: 180px;
    .bannerBg {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 100%;
    }
    .bannerImg {
      position: relative;
      z-index: 1;
      height: 100%;
    }
  }
  .notice {
    display: flex;
    line-height: 40px;
    color: #333;
    height: 40px;
    background: #fff;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font: 12px/40px "宋体", Verdana, Arial;
    &:hover {
        .main {
          animation-play-state: paused;
        }
      }
    /deep/ .el-carousel {
      width: calc(100% - 50px);
      .el-carousel__item {
        div {
          font: 12px/40px "宋体", Verdana, Arial;
        }
      }
    }
    .title {
      width: 30px;
      background: #fff;
      z-index: 33;
    }
    .main {
      color: #666;
      animation: ec-marquee-move 15s infinite linear;
      padding-right: 100px;
    }
  }
  .conLeft {
    .conTitle {
      font-size: 16px;
      padding-left: 10px;
      font-family: "微软雅黑";
    }
    .result {
      display: inline-flex;
      width: 100%;
      .auctionBox2 {
        width: calc(50% - 10px);
        &:nth-last-child(1) {
          margin-left: 20px;
        }
      }
      .resultTitleBox {
        border-top: 1px solid #dcdcdc;
        position: relative;
        height: 38px;
        .resultTitle {
          display: block;
          border-top: 3px solid #000;
          width: 74px;
          height: 36px;
          line-height: 36px;
          position: absolute;
          top: -1px;
          left: 0px;
        }
      }
      .resultUl {
        padding: 13px 19px 19px 19px;
        .resultItem {
          width: calc(50% - 15px);
          margin-right: 30px;
          &:nth-child(2n) {
            margin-right: 0px;
          }
        }
      }
    }
  }
  .conRight {
    .comInfo {
      .comTitle {
        .focusBtn {
          margin-right: 10px;
          float: right;
          line-height: 18px;
          font-size: 12px;
          color: #0099cc;
          font-weight: normal;
          cursor: pointer;
          i {
            float: left;
            width: 13px;
            height: 13px;
            margin-top: 2px;
            background: url(../../../assets/imgs/old/focusCompany.png) no-repeat
              0 0;
            margin-right: 5px;
            overflow: hidden;
          }
        }
      }
    }
    .newsList {
      /deep/ ul {
        padding: 0;
        li a {
          @include fontSong12;
          @include color333;
        }
        li:hover {
          a {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.ulFlex {
  display: flex;
}
 @keyframes ec-marquee-move {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

</style>
